<template>
  <div>
    <template v-if="loading">
      <v-skeleton-loader type="table-row-divider@6" />
    </template>
    <v-simple-table v-else dense class="main-table w-100">
      <template #default>
        <thead class="table-heading">
          <tr class="font-weight-bold">
            <th class="text-center text-dark font-weight-bold">Concepto</th>
            <th class="text-center text-dark font-weight-bold">
              Promedio semanal últimos 6 meses
            </th>
            <th
              v-for="week in data?.weeks"
              :key="week"
              class="text-center text-dark font-weight-bold"
            >
              Semana <br />
              {{ weekFormat(week) }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="row in data.rows"
            :key="row.concept"
            class="tb-border-gray"
          >
            <td
              class="text-nowrap bg-gray"
              :class="{
                'grey lighten-1 text-white font-weight-bold':
                  row.concept == totalKey,
              }"
            >
              {{ row.concept }}
            </td>
            <td
              :class="{
                'bg-gray font-weight-bold': isTotalRow(row),
              }"
            >
              {{ formatNumber(row.average, '$', 0) }}
            </td>
            <td
              v-for="week in data.weeks"
              :key="week"
              :class="{
                'font-weight-bold ': isTotalRow(row),
                'bg-gray text-success':
                  isTotalRow(row) && row.values[week] > row.average,
                'bg-gray text-danger':
                  isTotalRow(row) && row.values[week] < row.average,
              }"
            >
              {{ formatNumber(row.values[week], '$', 0) }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
  import numbersFormats from '@/mixins/numbersFormats';

  export default {
    name: 'WeeklyBudgetTable',
    mixins: [numbersFormats],
    props: {
      data: {
        type: Object,
        default: () => ({}),
      },
      loading: Boolean,
    },

    data() {
      return {
        weeks: [],
        totalKey: 'Total',
      };
    },
    computed: {},
    methods: {
      isTotalRow(row) {
        return row.concept == this.totalKey;
      },
      /* 
      week format: from 012026 to 01 / 2026
      */
      weekFormat(value) {
        return `${value.slice(-2)} / ${value.slice(0, 4)}`;
      },
    },
  };
</script>
<style scoped>
  .tb-border-gray td {
    border-color: lightgray;
    border-width: 2px;
  }
</style>
